function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }

function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }

function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }

function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }

import { Observable } from '../../tools/observable';
import { createValueHistory } from '../../tools/valueHistory';
import { clocksOrigin, dateNow, ONE_MINUTE, relativeNow } from '../../tools/utils/timeUtils';
import { addEventListener, addEventListeners } from '../../browser/addEventListener';
import { clearInterval, setInterval } from '../../tools/timer';
import { addTelemetryDebug } from '../telemetry';
import { isSyntheticsTest } from '../synthetics/syntheticsWorkerValues';
import { getCurrentSite } from '../../browser/cookie';
import { ExperimentalFeature, isExperimentalFeatureEnabled } from '../../tools/experimentalFeatures';
import { findLast } from '../../tools/utils/polyfills';
import { monitorError } from '../../tools/monitor';
import { SESSION_NOT_TRACKED, SESSION_TIME_OUT_DELAY, SessionPersistence } from './sessionConstants';
import { startSessionStore } from './sessionStore';
import { toSessionState } from './sessionState';
import { retrieveSessionCookie } from './storeStrategies/sessionInCookie';
import { SESSION_STORE_KEY } from './storeStrategies/sessionStoreStrategy';
import { retrieveSessionFromLocalStorage } from './storeStrategies/sessionInLocalStorage';
export var VISIBILITY_CHECK_DELAY = ONE_MINUTE;
var SESSION_CONTEXT_TIMEOUT_DELAY = SESSION_TIME_OUT_DELAY;
var stopCallbacks = [];
export function startSessionManager(configuration, productKey, computeTrackingType, trackingConsentState) {
  var renewObservable = new Observable();
  var expireObservable = new Observable(); // TODO - Improve configuration type and remove assertion

  var sessionStore = startSessionStore(configuration.sessionStoreStrategyType, configuration, productKey, computeTrackingType);
  stopCallbacks.push(function () {
    return sessionStore.stop();
  });
  var sessionContextHistory = createValueHistory({
    expireDelay: SESSION_CONTEXT_TIMEOUT_DELAY
  });
  stopCallbacks.push(function () {
    return sessionContextHistory.stop();
  });
  sessionStore.renewObservable.subscribe(function () {
    sessionContextHistory.add(buildSessionContext(), relativeNow());
    renewObservable.notify();
  });
  sessionStore.expireObservable.subscribe(function () {
    expireObservable.notify();
    sessionContextHistory.closeActive(relativeNow());
  }); // We expand/renew session unconditionally as tracking consent is always granted when the session
  // manager is started.

  sessionStore.expandOrRenewSession();
  sessionContextHistory.add(buildSessionContext(), clocksOrigin().relative);

  if (isExperimentalFeatureEnabled(ExperimentalFeature.SHORT_SESSION_INVESTIGATION)) {
    var session = sessionStore.getSession();

    if (session) {
      detectSessionIdChange(configuration, session);
    }
  }

  trackingConsentState.observable.subscribe(function () {
    if (trackingConsentState.isGranted()) {
      sessionStore.expandOrRenewSession();
    } else {
      sessionStore.expire(false);
    }
  });
  trackActivity(configuration, function () {
    if (trackingConsentState.isGranted()) {
      sessionStore.expandOrRenewSession();
    }
  });
  trackVisibility(configuration, function () {
    return sessionStore.expandSession();
  });
  trackResume(configuration, function () {
    return sessionStore.restartSession();
  });

  function buildSessionContext() {
    var session = sessionStore.getSession();

    if (!session) {
      reportUnexpectedSessionState(configuration)["catch"](function () {
        return void 0;
      }); // Ignore errors

      return {
        id: 'invalid',
        trackingType: SESSION_NOT_TRACKED,
        isReplayForced: false,
        anonymousId: undefined
      };
    }

    return {
      id: session.id,
      trackingType: session[productKey],
      isReplayForced: !!session.forcedReplay,
      anonymousId: session.anonymousId
    };
  }

  return {
    findSession: function findSession(startTime, options) {
      return sessionContextHistory.find(startTime, options);
    },
    renewObservable: renewObservable,
    expireObservable: expireObservable,
    sessionStateUpdateObservable: sessionStore.sessionStateUpdateObservable,
    expire: sessionStore.expire,
    updateSessionState: sessionStore.updateSessionState
  };
}
export function stopSessionManager() {
  stopCallbacks.forEach(function (e) {
    return e();
  });
  stopCallbacks = [];
}

function trackActivity(configuration, expandOrRenewSession) {
  var _addEventListeners = addEventListeners(configuration, window, ["click"
  /* DOM_EVENT.CLICK */
  , "touchstart"
  /* DOM_EVENT.TOUCH_START */
  , "keydown"
  /* DOM_EVENT.KEY_DOWN */
  , "scroll"
  /* DOM_EVENT.SCROLL */
  ], expandOrRenewSession, {
    capture: true,
    passive: true
  }),
      stop = _addEventListeners.stop;

  stopCallbacks.push(stop);
}

function trackVisibility(configuration, expandSession) {
  var expandSessionWhenVisible = function expandSessionWhenVisible() {
    if (document.visibilityState === 'visible') {
      expandSession();
    }
  };

  var _addEventListener = addEventListener(configuration, document, "visibilitychange"
  /* DOM_EVENT.VISIBILITY_CHANGE */
  , expandSessionWhenVisible),
      stop = _addEventListener.stop;

  stopCallbacks.push(stop);
  var visibilityCheckInterval = setInterval(expandSessionWhenVisible, VISIBILITY_CHECK_DELAY);
  stopCallbacks.push(function () {
    clearInterval(visibilityCheckInterval);
  });
}

function trackResume(configuration, cb) {
  var _addEventListener2 = addEventListener(configuration, window, "resume"
  /* DOM_EVENT.RESUME */
  , cb, {
    capture: true
  }),
      stop = _addEventListener2.stop;

  stopCallbacks.push(stop);
}

function reportUnexpectedSessionState(_x) {
  return _reportUnexpectedSessionState.apply(this, arguments);
}

function _reportUnexpectedSessionState() {
  _reportUnexpectedSessionState = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(configuration) {
    var sessionStoreStrategyType, rawSession, cookieContext;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            sessionStoreStrategyType = configuration.sessionStoreStrategyType;

            if (sessionStoreStrategyType) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return");

          case 3:
            if (!(sessionStoreStrategyType.type === SessionPersistence.COOKIE)) {
              _context.next = 12;
              break;
            }

            rawSession = retrieveSessionCookie(sessionStoreStrategyType.cookieOptions, configuration);
            _context.next = 7;
            return getSessionCookies();

          case 7:
            _context.t0 = _context.sent;
            _context.t1 = "".concat(window.location.protocol, "//").concat(window.location.hostname);
            cookieContext = {
              cookie: _context.t0,
              currentDomain: _context.t1
            };
            _context.next = 13;
            break;

          case 12:
            rawSession = retrieveSessionFromLocalStorage();

          case 13:
            // monitor-until: forever, could be handy to troubleshoot issues until session manager rework
            addTelemetryDebug('Unexpected session state', _objectSpread({
              sessionStoreStrategyType: sessionStoreStrategyType.type,
              session: rawSession,
              isSyntheticsTest: isSyntheticsTest(),
              createdTimestamp: rawSession === null || rawSession === void 0 ? void 0 : rawSession.created,
              expireTimestamp: rawSession === null || rawSession === void 0 ? void 0 : rawSession.expire
            }, cookieContext));

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _reportUnexpectedSessionState.apply(this, arguments);
}

function detectSessionIdChange(configuration, initialSessionState) {
  if (!window.cookieStore || !initialSessionState.created) {
    return;
  }

  var sessionCreatedTime = Number(initialSessionState.created);
  var sdkInitTime = dateNow();

  var _addEventListener3 = addEventListener(configuration, cookieStore, "change"
  /* DOM_EVENT.CHANGE */
  , listener),
      stop = _addEventListener3.stop;

  stopCallbacks.push(stop);

  function listener(event) {
    var changed = findLast(event.changed, function (change) {
      return change.name === SESSION_STORE_KEY;
    });

    if (!changed) {
      return;
    }

    var sessionAge = dateNow() - sessionCreatedTime;

    if (sessionAge > 14 * ONE_MINUTE) {
      // The session might have expired just because it's too old or lack activity
      stop();
    } else {
      var newSessionState = toSessionState(changed.value);

      if (newSessionState.id && newSessionState.id !== initialSessionState.id) {
        stop();
        var time = dateNow() - sdkInitTime;
        getSessionCookies().then(function (cookie) {
          // monitor-until: 2025-12-01, after RUM-10845 investigation done
          addTelemetryDebug('Session cookie changed', {
            time: time,
            session_age: sessionAge,
            old: initialSessionState,
            "new": newSessionState,
            cookie: cookie
          });
        })["catch"](monitorError);
      }
    }
  }
}

function getSessionCookies() {
  return _getSessionCookies.apply(this, arguments);
}

function _getSessionCookies() {
  _getSessionCookies = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var sessionCookies;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!('cookieStore' in window)) {
              _context2.next = 6;
              break;
            }

            _context2.next = 3;
            return window.cookieStore.getAll(SESSION_STORE_KEY);

          case 3:
            sessionCookies = _context2.sent;
            _context2.next = 7;
            break;

          case 6:
            sessionCookies = document.cookie.split(/\s*;\s*/).filter(function (cookie) {
              return cookie.startsWith(SESSION_STORE_KEY);
            });

          case 7:
            return _context2.abrupt("return", _objectSpread({
              count: sessionCookies.length,
              domain: getCurrentSite() || 'undefined'
            }, sessionCookies));

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getSessionCookies.apply(this, arguments);
}